import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import AppProducts from '@/plugins/graphql/queries/v2/app-products.gql';
import AppProductVariants from '@/plugins/graphql/queries/v2/app-product-variants.gql';
import AppSingleVariants from '@/plugins/graphql/queries/v2/app-single-variants.gql';
import { EcommerceProductModel } from '@/helpers/entities/models/EcommerceProductModel';
import '@/assets/stylesheets/v2/_mdr-dialog.scss';
import { EcommerceProductOptionModel } from '@/helpers/entities/models/EcommerceProductOptionModel';
import { EcommerceProductVariantModel } from '@/helpers/entities/models/EcommerceProductVariantModel';
let TuckingQuestion = class TuckingQuestion extends Mixins() {
    back() {
        this.$emit('back');
    }
    decline() {
        this.$emit('decline');
    }
    async confirm() {
        this.$emit('confirm');
    }
    get availableProducts() {
        const vm = this;
        const prodArray = [...vm.products, ...vm.singleVariants, ...vm.multiVariants];
        vm.isLoading = false;
        return prodArray;
    }
};
__decorate([
    Prop({ type: String, required: true })
], TuckingQuestion.prototype, "appUuid", void 0);
TuckingQuestion = __decorate([
    Component({
        apollo: {
            products: {
                query: AppProducts,
                variables() {
                    return {
                        appUuid: this.appUuid,
                    };
                },
                update(data) {
                    const products = data.fetchAvailableProducts.edges;
                    const productNode = (product) => {
                        return new EcommerceProductModel(product.node);
                    };
                    return products.map(productNode);
                },
            },
            multiVariants: {
                query: AppProductVariants,
                variables() {
                    return {
                        appUuid: this.appUuid,
                    };
                },
                update(data) {
                    const products = data.fetchAvailableProductVariants.edges;
                    const productVariantNode = (productVariant) => {
                        return new EcommerceProductVariantModel(productVariant.node);
                    };
                    return products.map(productVariantNode);
                },
            },
            singleVariants: {
                query: AppSingleVariants,
                variables() {
                    return {
                        appUuid: this.appUuid,
                    };
                },
                update(data) {
                    const products = data.fetchSingleVariantProducts.edges;
                    const productOptionNode = (productOption) => {
                        return new EcommerceProductOptionModel(productOption.node);
                    };
                    return products.map(productOptionNode);
                },
            },
        },
        data() {
            return {
                isLoading: true,
            };
        },
    })
], TuckingQuestion);
export default TuckingQuestion;
